import React, { useEffect, useState } from 'react';
import {
    Box,
    TextField,
    IconButton,
    Button,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Visibility as VisibilityIcon,
    Close as CloseIcon,
    AccountBalance as AccountBalanceIcon,
} from '@mui/icons-material';

import {
    DataGridPro,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarDensitySelector
} from '@mui/x-data-grid-pro';

import axios from '../../../axios-order';

import {
    Container,
    Grid
} from '@mui/material';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoadingButton } from '@mui/lab';
import { Settings } from "@mui/icons-material";
import SelectInput from "../../../components/ui/basicSelectInput";

const ServiceTable = () => {
    const [supplierData, setSupplierData] = useState([]);
    const [formData, setFormData] = useState({
        gstin: '',
        next_number: '',
        prefix: '',
        service_name: '',
        suffix: '',
        common_services_id: '' // Track the service ID for updates
    });

    const [supplierFormDialogOpen, setSupplierFormDialogOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({});
    const [supplierDailogKey, setSupplierDailogKey] = useState('');
    const [error, setError] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("");
    const [message, setMessage] = useState('');
    const [responseMessage, setResponseMessage] = useState("");
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    const [form16DataLoading, setForm16DataLoading] = useState(false);
    const [gstArray, setGstArray] = useState([])

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarSeverity(severity);
        setResponseMessage(message);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setSnackbarSeverity("");
        setResponseMessage("");
    };

    const columns = [
        {
            field: 'service_name',
            headerName: 'Service Name',
            flex: 1,
            minWidth: 150,
            align: 'left',
            filterable: true,
        },
        {
            field: 'prefix',
            headerName: 'Prefix',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'suffix',
            headerName: 'Suffix',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'next_number',
            headerName: 'Next Number',
            flex: 1,
            minWidth: 200,
            align: 'left',
            filterable: true,
        },
        {
            field: 'actions',
            headerName: 'Action',
            flex: 1,
            minWidth: 200,
            align: 'left',
            renderCell: (params) => {
                const row = params.row;
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenServiceFormDialog("view", row.common_services_id)}
                            title="View Service"
                        >
                            <VisibilityIcon fontSize="medium" style={{ color: '#455a64' }} />
                        </IconButton>
                        <IconButton
                            size="medium"
                            onClick={() => handleOpenServiceFormDialog("edit", row.common_services_id)}
                            title={row.editable ? 'Edit Service' : 'Tax Invoice Generated, Cannot Edit'}
                            disabled={!row.editable}
                            style={{ pointerEvents: row.editable ? 'auto' : 'auto' }}
                        >
                            {/* <EditIcon fontSize="medium" style={{ color: '#455a64' }} /> */}
                            <EditIcon fontSize="medium" style={{ color: row.editable ? '#455a64' : '#B0BEC5' }} />
                        </IconButton>
                    </div>
                );
            },
            filterable: false,
        },
    ];

    useEffect(() => {
        getServiceData();
        getGstinInfo()
    }, []);

    const getGstinInfo = () => {
        axios.get(`/einvoice/get_gst_info/${localStorage.getItem('business_entity_id')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const gstList = res?.data?.records || []
                    if (gstList && gstList.length == 1) {
                        console.log("form data ............updating the gstin.........", gstList[0].gstin)
                        setFormData(prev => ({
                            ...prev,
                            gstin: gstList[0].gstin
                        }));

                    }
                    setGstArray(gstList)
                }
            }).catch((err) => {

            })
    }

    const getServiceData = () => {
        setForm16DataLoading(true);
        axios.get(`/e_invoice_service_details/${localStorage.getItem('business_entity_id')}/${localStorage.getItem('gst')}`)
            .then((res) => {
                if (res?.data?.status) {
                    const records = res?.data?.records;
                    setSupplierData(records);
                }
            }).catch((err) => {

            }).finally(() => {
                setForm16DataLoading(false);
            });
    };

    const handleOpenServiceFormDialog = (dailogKey, common_services_id = null) => {
        setSupplierDailogKey(dailogKey);
        if (common_services_id && (dailogKey === "edit" || dailogKey === "view")) {
            // Find the service in supplierData
            const service = supplierData.find((item) => item.common_services_id === common_services_id);
            console.log(service.next_number);

            if (service) {
                setFormData({
                    gstin: service.gstin || '',
                    service_name: service.service_name || '',
                    prefix: service.prefix || '',
                    next_number: String(service.next_number ?? ''),
                    suffix: service.suffix || '',
                    common_services_id: common_services_id
                });
            } else {
                setFormData({
                    gstin: formData.gstin,
                    service_name: '',
                    prefix: '',
                    next_number: '',
                    suffix: '',
                    common_services_id: ''
                });
            }
        } else {
            setFormData({
                gstin: formData.gstin,
                service_name: '',
                prefix: '',
                next_number: '',
                suffix: '',
                common_services_id: ''
            });
        }
        setSupplierFormDialogOpen(true);
    };

    const clearSupplierForm = () => {
        setFormData({
            gstin: formData.gstin,
            service_name: '',
            prefix: '',
            next_number: '',
            suffix: '',
            common_services_id: ''
        });
        setError('');
    };

    const handleCloseServiceFormDialog = () => {
        clearSupplierForm();
        setSubmitButtonLoading(false);
        setSupplierFormDialogOpen(false);
        setSelectedCompany({});
    };

    const handleDeleteService = (record) => {
        setSelectedCompany(record);
        // Implement delete logic here if needed
    };

    const CustomToolbar = () => (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                height: '60px',
                flexWrap: 'wrap',
                gap: 1,
                padding: '3px 10px',
                backgroundColor: '#ffffff',
                borderRadius: '4px',
                boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            }}
        >
            <Box sx={{ display: 'flex', gap: 1 }}>
                <GridToolbarColumnsButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarFilterButton
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
                <GridToolbarDensitySelector
                    sx={{
                        variant: 'outlined',
                        borderColor: '#1976d2',
                        color: '#1976d2',
                        borderRadius: '4px',
                        padding: '2px 4px',
                        '&:hover': {
                            borderColor: '#1565c0',
                            backgroundColor: '#e3f2fd',
                        }
                    }}
                />
            </Box>
            <Box sx={{ display: 'flex', gap: 1, alignSelf: 'center' }}>
                <Button
                    variant="contained"
                    startIcon={<Settings />}
                    onClick={() => handleOpenServiceFormDialog("add")}
                    style={{ height: '40px', backgroundColor: '#00b0ff' }}
                >
                    Add Service
                </Button>
            </Box>
        </Box>
    );

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const updateService = (payLoadData) => {
        axios.post('/e_invoice_service_update', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseServiceFormDialog();
                } else {
                    handleSnackbarOpen(res.data.message || 'Failed to update service', 'error');
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false);
                getServiceData();
            });
    };

    const createService = (payLoadData) => {
        axios.post('/e_invoice_service_create', payLoadData)
            .then((res) => {
                if (res?.data?.status) {
                    handleSnackbarOpen(res.data.message, 'success');
                    handleCloseServiceFormDialog();
                } else {
                    handleSnackbarOpen(res.data.message || 'Failed to create service', 'error');
                }
            }).catch((err) => {

            }).finally(() => {
                setSubmitButtonLoading(false);
                getServiceData();
            });
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setSubmitButtonLoading(true);
        const payLoadData = {
            ...formData,
            business_entity_id: localStorage.getItem('business_entity_id'),
            common_services_id: formData.common_services_id,
            entity_gstin: localStorage.getItem('gst'),
            branch_name: localStorage.getItem('branch_name')
        };

        switch (supplierDailogKey) {
            case "edit":
                updateService(payLoadData);
                break;
            default:
                createService(payLoadData);
                break;
        }
    };
    // console.log("form data...............", formData)
    const AddCompanyDialog = () => {
        const isViewMode = supplierDailogKey === 'view';
        const isEditMode = supplierDailogKey === "edit";

        // Construct the formatted string (e.g., TEST/2022/data/56)
        const formattedString = `${formData.prefix || ''}/${formData.suffix || ''}/${formData.next_number || ''}`.replace(/\/+/g, '/').replace(/^\/|\/$/g, '');

        return (
            <div sx={{ width: '100%', bgcolor: 'background.paper', borderRadius: 1, boxShadow: 1 }}>
                <Container maxWidth="lg" sx={{ py: 4 }}>
                    <ValidatorForm
                        useRef="form"
                        onSubmit={handleSubmit}
                        onError={(errors) => console.log(errors)}
                    >
                        <Box sx={{ mb: 2 }}>
                            {/* <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Basic Information
                            </Typography> */}
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4} mt={1}>

                                    <SelectInput
                                        choice_id="gstin"
                                        requiredField="*"
                                        validator={["required"]}
                                        errorMsg={["This field is required"]}
                                        choice_name="entity_name"
                                        SelectLabel="ENTITY NAME"
                                        name="gstin"
                                        value={formData.gstin}
                                        textOnchangeFunction={handleChange}
                                        choices={gstArray}
                                        disabled={isEditMode || isViewMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Service Name</label>
                                    <span style={{ color: "red" }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="service_name"
                                        value={formData.service_name}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={['required']}
                                        errorMessages={["Service Name is required"]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Prefix</label>
                                    <span style={{ color: "red" }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="prefix"
                                        value={formData.prefix}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                        validators={['required']}
                                        errorMessages={["Prefix is required"]}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Suffix</label>
                                    <span style={{ color: "red" }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="suffix"
                                        value={formData.suffix}
                                        onChange={handleChange}
                                        validators={['required']}
                                        errorMessages={["Suffix is required"]}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <label>Next Number</label>
                                    <span style={{ color: "red" }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="next_number"
                                        value={formData.next_number}
                                        onChange={handleChange}
                                        inputProps={{
                                            maxLength: 100,
                                            readOnly: isViewMode,
                                            pattern: "[0-9]*"  // Only digits allowed
                                        }}
                                        onKeyPress={(event) => {
                                            // Prevent any non-digit key
                                            if (!/[0-9]/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        validators={['required', 'matchRegexp:^[0-9]*$']}
                                        errorMessages={[
                                            "Next Number is required",
                                            "Only numbers (0-9) are allowed"
                                        ]}
                                    />
                                </Grid>
                                {/* <Grid item xs={12} sm={4}>
                                    <label>Next Number</label>
                                    <span style={{ color: "red" }}>*</span>:
                                    <TextValidator
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        name="next_number"
                                        value={formData.next_number}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 100, readOnly: isViewMode, pattern: "[0-9\\W]*" }}
                                        onKeyPress={(event) => {
                                            if (/^[a-zA-Z]$/.test(event.key)) {
                                                event.preventDefault();
                                            }
                                        }}
                                        validators={['required','matchRegexp:^[0-9\\W]*$']}
                                        errorMessages={["Next Number is required", "Only numbers and special characters are allowed"]}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <Typography variant="body1" sx={{ mt: 2, fontWeight: 'bold' }}>
                                        Invoice Number Format:
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        value={formattedString}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        sx={{ mt: 1 }}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                        {!isViewMode && (
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                                <Button variant="outlined" sx={{ mr: 2 }} onClick={clearSupplierForm}>
                                    Clear
                                </Button>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    loading={submitButtonLoading}
                                >
                                    Submit
                                </LoadingButton>
                            </Box>
                        )}
                    </ValidatorForm>
                </Container>
            </div>
        );
    };

    return (
        <div>
            <Box sx={{ height: '65vh', width: '100%', marginTop: '0.8%' }}>
                <DataGridPro
                    rows={supplierData}
                    columns={columns}
                    loading={form16DataLoading}
                    localeText={{
                        toolbarDensity: 'Size',
                        toolbarDensityLabel: 'Size',
                        toolbarDensityCompact: 'Small',
                        toolbarDensityStandard: 'Medium',
                        toolbarDensityComfortable: 'Large',
                    }}
                    sx={{
                        maxHeight: '65vh',
                        '& .MuiDataGrid-columnHeaders': {
                            color: '#fff',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                            textAlign: 'right',
                            zIndex: 1000,
                        },
                        '& .MuiDataGrid-columnHeader': {
                            position: 'relative',
                            textAlign: 'right',
                            width: '100%',
                            fontWeight: 'bold',
                            backgroundColor: '#607d8b',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            color: '#fff',
                        },
                        "& .MuiDataGrid-sortIcon": {
                            opacity: 'inherit !important',
                        },
                        "& .MuiDataGrid-iconButtonContainer": {
                            visibility: 'visible',
                        },
                        '& .MuiDataGrid-menuIconButton': {
                            opacity: '1 !important',
                            visibility: 'visible !important',
                            display: 'flex !important',
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            '& .MuiDataGrid-columnHeader': {
                                '& .MuiDataGrid-menuIconButton': {
                                    display: 'flex !important',
                                    visibility: 'visible !important',
                                    opacity: '1 !important',
                                },
                            },
                        },
                        '& .MuiDataGrid-columnHeaderIcon': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-columnHeader .MuiIconButton-root': {
                            color: '#fff',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: '#f9f9f9',
                        },
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: '#ffffff',
                        },
                        '& .MuiDataGrid-cell': {
                            padding: '8px',
                            textAlign: 'center',
                        },
                        '& .MuiDataGrid-footerContainer': {
                            backgroundColor: '#f0f0f0',
                        },
                        '& .MuiCheckbox-root': {
                            color: '#1976d2',
                        },
                        '& .MuiDataGrid-row:hover': {
                            backgroundColor: '#d3e3fc',
                            cursor: 'pointer'
                        },
                    }}
                    pagination
                    pageSize={5}
                    pageSizeOptions={[5, 10, 25, 50]}
                    components={{
                        Toolbar: CustomToolbar,
                    }}
                />
            </Box>
            <Dialog
                open={supplierFormDialogOpen}
                onClose={handleCloseServiceFormDialog}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        boxShadow: 24,
                        px: 2,
                        py: 1,
                        marginLeft: 8,
                        bgcolor: 'background.default'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: 1,
                        borderColor: 'divider',
                    }}
                >
                    <Box display="flex" alignItems="center" gap={1}>
                        <Settings color="primary" />
                        <Typography variant="h6" fontWeight="bold">
                            {supplierDailogKey === 'add' && 'Add Service'}
                            {supplierDailogKey === 'edit' && 'Edit Service'}
                            {supplierDailogKey === 'view' && 'View Service'}
                        </Typography>
                    </Box>
                    <IconButton onClick={handleCloseServiceFormDialog} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ px: 3, py: 2 }}>
                    {AddCompanyDialog()}
                </DialogContent>
                <DialogActions
                    sx={{
                        justifyContent: 'flex-end',
                        px: 3,
                        py: 2,
                        borderTop: 1,
                        borderColor: 'divider',
                        bgcolor: 'background.default',
                    }}
                >
                    <Button onClick={handleCloseServiceFormDialog} variant="outlined">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={4500}
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </div>
    );
};

export default ServiceTable;